import React, { Dispatch, useRef } from 'react';
import { Box, Stack } from '@mui/material';
import { modalTitle, SUGGESTED_PROMPTS_DESCRIPTION, SUGGESTED_PROMPTS_QUESTIONS } from '../config';
import { classes } from '../styles';
import { AIStudioState, AIStudioAction } from '../reducer';
import { FelixMessageSVG } from '../../SharedComponents/Graphics/FelixSVG';
import { FeedbackInput } from '../components/FeedbackInput';

type GenerationType = 'description' | 'questions';

const DisplayResponseFooter = ({
  aiStudioState,
  dispatch,
  generateDescription,
  generateQuestions
}: {
  aiStudioState: AIStudioState;
  dispatch: Dispatch<AIStudioAction>;
  generateDescription: (feedbackInput?: string) => void;
  generateQuestions: (feedbackInput?: string) => void;
}) => {
  const footerRef = useRef<HTMLDivElement>(null);
  const handleSubmit = (input: string) => {
    if (aiStudioState.generationType === 'description') {
      generateDescription(input);
    } else {
      generateQuestions(input);
    }
  };

  return (
    <Box sx={classes.footerContainer} ref={footerRef}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        alignItems="flex-start"
        sx={{ width: '100%' }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexShrink: 0 }}>
          <FelixMessageSVG />
        </Box>
        <Box sx={{ ...classes.felixMessage, flex: 1, minWidth: 0 }}>
          <Box sx={{ paddingRight: { xs: 0, sm: '80px' } }}>
            {aiStudioState.aiStudioFrenchEnabled ? (
              <>
                <span>Voilà!</span> Votre{' '}
                <span>
                  {
                    modalTitle[aiStudioState.aiStudioFrenchEnabled ? 'french' : 'english'][
                      aiStudioState.generationType as GenerationType
                    ]
                  }
                </span>{' '}
                {aiStudioState.generationType === 'description' ? 'est' : 'sont'} prêt
                {aiStudioState.generationType === 'description' ? '' : 's'} à l&apos;action. Vous
                pouvez l&apos;utiliser tel quel ou apporter des ajustements avant de le publier.
              </>
            ) : (
              <>
                Ta-da! Your{' '}
                <span>
                  {
                    modalTitle[aiStudioState.aiStudioFrenchEnabled ? 'french' : 'english'][
                      aiStudioState.generationType as GenerationType
                    ]
                  }
                </span>{' '}
                {aiStudioState.generationType === 'description' ? 'is' : 'are'} ready for action.
                You may want to use{' '}
                {aiStudioState.generationType === 'description' ? 'this' : 'them'} as is, or make
                some adjustments before publishing.
              </>
            )}
          </Box>
          <Box sx={{ width: '100%', minWidth: 0 }}>
            <FeedbackInput
              value={aiStudioState.refinedResponse}
              onChange={(value: string) =>
                dispatch({ type: 'SET_REFINED_RESPONSE', payload: value })
              }
              onSubmit={handleSubmit}
              suggestedPrompts={
                aiStudioState.generationType === 'description'
                  ? SUGGESTED_PROMPTS_DESCRIPTION
                  : SUGGESTED_PROMPTS_QUESTIONS
              }
              isLoading={aiStudioState.isLoading}
              language={aiStudioState.aiStudioFrenchEnabled ? 'french' : 'english'}
            />
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default DisplayResponseFooter;
